import { createAction, props } from '@ngrx/store';
import { LogedUser } from '../../core/models/logged-user.model';

export const LOGGED_USER_SET = '[LOGGED_USER] Set logged user';

export const setLoggedUser = createAction(
  LOGGED_USER_SET,
  props<{ loggedUser: LogedUser }>()
);
